import * as React from "react";
import { connect } from "react-redux";
import { IdStyles } from "../../less/IdStyles";
import { IdLoca } from "../../utils/i18n/IdLoca";
import { DialogWrapper } from "../dialog/DialogWrapper";
import { DialogContent } from "../errors/DialogContent";
import { ButtonPrimary } from "../generic/common/ButtonPrimary";
import { TextLoca } from "../generic/text/TextLoca";
import { actionModalClose } from "../modals/actionModal";
import { IdModal } from "../modals/IdModal";
var _DialogFeedbackConfirmation = function (_a) {
    var onClose = _a.onClose;
    return (React.createElement(DialogWrapper, { titleLocaId: IdLoca.settingsMenu_feedback, className: IdStyles.ModalBackground, onClose: onClose },
        React.createElement("div", { className: "flex flex--guts flex--stacked w100 h100" },
            React.createElement(DialogContent, { messageLocaId: IdLoca.floatingText_feedbackSent }),
            React.createElement("div", { className: "button-ribbon" },
                React.createElement(ButtonPrimary, { onClick: onClose },
                    React.createElement("div", { className: IdStyles.TextBoldAccent },
                        React.createElement(TextLoca, { className: IdStyles.TextButtonDefault, id: IdLoca.confirm })))))));
};
var mapDispatch = function (dispatch) { return ({
    onClose: function () {
        dispatch(actionModalClose(IdModal.FeedbackConfirmation));
    },
}); };
export var DialogFeedbackConfirmation = connect(undefined, mapDispatch)(_DialogFeedbackConfirmation);



//////////////////
// WEBPACK FOOTER
// ./src/features/feedback/DialogFeedbackConfirmation.tsx
// module id = 2833
// module chunks = 3